module.exports = __webpack_public_path__ + "static/media/discount.85a97f66.png";


//////////////////
// WEBPACK FOOTER
// /src/images/about/discount.png
// module id = 1594
// module chunks = 0